const slickFade = () => {
  var ie9 = $('html').hasClass('ie9')
  var ie8 = $('html').hasClass('ie8')
  var $slick = $('.ty-SlickSlide,.ty-Slick')

  if (ie9 || ie8) {
    $slick.css({opacity: 1})
  } else {
    $slick.imagesLoaded(function () {
      $slick.addClass('in')
    })
  }
}

module.exports = slickFade



// WEBPACK FOOTER //
// ./src/js/lib/slick-fade.js